/* ============================== Rich text — Read more clamp ============================== */
if (!customElements.get('engo-read-more')) {
  customElements.define(
    'engo-read-more',
    class EngoReadMore extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-read-more-toggle]');
        this.labelMore = this.querySelector('[data-read-more-label-more]');
        this.labelLess = this.querySelector('[data-read-more-label-less]');

        if (!this.toggle) return;

        this.toggle.addEventListener('click', () => this.onToggle());
      }

      onToggle() {
        const expanded = this.toggleAttribute('data-expanded');

        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (this.labelMore) this.labelMore.hidden = expanded;
        if (this.labelLess) this.labelLess.hidden = !expanded;
      }
    }
  );
}

/* ============================== Media gallery with tabs ============================== */
if (!customElements.get('engo-media-gallery-tabs')) {
  customElements.define(
    'engo-media-gallery-tabs',
    class EngoMediaGalleryTabs extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.tabs = Array.from(this.querySelectorAll('[data-gallery-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-gallery-panel]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), { signal });
        });

        this.addEventListener('keydown', (event) => this.onKeydown(event), { signal });

        if (window.Shopify && window.Shopify.designMode) {
          document.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });
        }
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

      select(index) {
        if (!this.panels[index]) return;

        this.tabs.forEach((tab, i) => tab.setAttribute('aria-selected', i === index ? 'true' : 'false'));
        this.panels.forEach((panel, i) => (panel.hidden = i !== index));
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;

        const currentIndex = this.tabs.indexOf(document.activeElement);
        if (currentIndex === -1) return;

        const offset = event.key === 'ArrowRight' ? 1 : -1;
        const nextIndex = (currentIndex + offset + this.tabs.length) % this.tabs.length;

        this.select(nextIndex);
        this.tabs[nextIndex].focus();
      }

      onBlockSelect(event) {
        if (!this.contains(event.target)) return;

        const tabIndex = this.tabs.indexOf(event.target);
        if (tabIndex !== -1) return this.select(tabIndex);

        const panel = event.target.closest('[data-gallery-panel]');
        if (panel) this.select(this.panels.indexOf(panel));
      }
    }
  );
}

/* ============================== Variant gallery — jump to the first slide ============================== */
/* <product-rerender> already swapped the gallery; this only undoes the theme's jump to variant.featured_media,
   whose position does not map to a metafield-driven gallery. */
document.addEventListener('variant:change', (event) => {
  if (!event.detail.variant) return;

  const formId = event.target.getAttribute('id');
  const gallery = document.querySelector(`product-gallery[variant-media][form="${formId}"]`);
  if (!gallery) return;

  gallery.querySelectorAll('media-carousel').forEach((carousel) => {
    const index = Array.from(carousel.children).findIndex((slide) => !slide.hidden);
    if (index !== -1) carousel.select(index, { animate: false });
  });
});
